import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['cityInput']
  static values = { cities: Array }

  connect() {
    if (this.hasCityInputTarget && this.hasCitiesValue) {
      $(this.cityInputTarget).autocomplete({
        source: this.citiesValue,
        minLength: 2
      })
    }
  }
}
